import { useEffect, useRef } from 'react';
import { whenStyleReady } from './utils';

function Source({ map, name, type = 'vector', ...props }) {
    const latest = useRef(props);

    // In an effect, not during render: an abandoned render must not leave a stale value behind.
    useEffect(() => {
        latest.current = props;
    });

    useEffect(() => {
        if (!map) return undefined;

        const add = () => {
            if (!map.getSource(name)) {
                map.addSource(name, {
                    ...latest.current,
                    type: 'vector',
                    promoteId: 'mapbox_id',
                });
            }
        };

        // Deliberately never removed: sibling cleanups run in mount order, so this would tear
        // down before the layers sharing it and mapbox would throw. Adding is idempotent.
        return whenStyleReady(map, add);
    }, [map, name]);

    return null;
}

export default Source;
